import config from '../config';
import notification from 'c-notification';

let getRequestToken = () => {
    $.ajax({
        url: config.getTwitterRequestTokenPath(),
        data: {
            callback: encodeURIComponent(location.href)
        },
        type: 'GET',
        dataType: 'json'
    }).then((resp)=>{
        $('#wrap').empty();
        return resp;
    }).done((resp) => {
        $.channel.emit('getTwitterOauthTokenSuccess', resp);
    }).fail(()=>{
        notification.simple('request fail');
    });
};

export default {
    getRequestToken
};


// WEBPACK FOOTER //
// ./js/sns/twitter.js